
@if (tag !== null && !tag.special) {
<app-tags-regular
    [tag]="tag"
    [metaEventSlice]="10"
    (updateMeta)="onUpdateMetaObject($event)"

/>
}

@if (tag !== null && tag.special) {
<app-tags-special
    [tag]="tag"
    [metaEventSlice]="10"
    (updateMeta)="onUpdateMetaObject($event)"
/>
}
